import { render } from "./BuyInsTable.vue?vue&type=template&id=c0d33bd0&scoped=true"
import script from "./BuyInsTable.vue?vue&type=script&lang=js"
export * from "./BuyInsTable.vue?vue&type=script&lang=js"

import "./BuyInsTable.vue?vue&type=style&index=0&id=c0d33bd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d33bd0"]])

export default __exports__